import type { Registry } from '../../common/types.tsx';
import createEntry from '../../common/utils/api/index.tsx';
import { props } from './constants.tsx';

interface LabelSuggestion {
	value?: string;
	label: string;
	html?: string;
	color?: string;
}

const labelsCaches: { [labelsFieldId: string]: Registry<LabelSuggestion> } = {};

export const getLabelsCache = (labelsFieldId?: string) => {
	const cacheKey = labelsFieldId || props.cacheKey;
	if (!labelsCaches[cacheKey]) {
		labelsCaches[cacheKey] = createEntry({
			...props,
			cacheKey,
		});
	}
	return labelsCaches[cacheKey];
};
